import { api, endpoint } from "@/api";
import { userRole } from "@/constant";
import { DatePicker, Form, InputNumber, Radio, Select } from "antd";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

const { RangePicker } = DatePicker;
const ComparisonTimes = ({ formData }) => {
  const { userDetails } = useSelector((state) => state.user);

  const { devices, intervalTime } = formData;

  // states
  const [hostingYears, setHostingYears] = useState(0);

  // effects
  useEffect(() => {
    if (devices?.[0]?.business) getMySubscription(devices?.[0]?.business);
  }, [devices?.[0]?.business]);

  // fetch
  const getMySubscription = async (business) => {
    try {
      const { hasAccess } = await api.get(endpoint.mySubscription, {
        params: {
          business,
          type: "analysis",
        },
      });
      setHostingYears(hasAccess ? 2 : 0);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(e);
    }
  };

  // handler

  const disabledDate = (current) =>
    current > moment() ||
    (moment().subtract(hostingYears, "year") > current &&
      userDetails?.role !== userRole.superAdmin &&
      hostingYears !== 0);

  return (
    <>
      {/* select time range */}
      <Form.Item label="Select Time" name="timeRange">
        <RangePicker
          placeholder={["Select Start Date", "Select End Date"]}
          disabledDate={(date) => disabledDate(date)}
          className="w-100"
        />
      </Form.Item>

      <Row>
        <Col xs={6}>
          <Form.Item label="Select Interval" name="intervalTime">
            <Select
              showSearch
              filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
              maxTagCount="responsive"
              placeholder="Select Interval"
              options={[
                { label: "Real Time", value: "" },
                { label: "Minute", value: 1 },
                { label: "Hour", value: 60 },
                { label: "Day", value: 1440 },
                { label: "Monthly", value: 43830 },
                { label: "Yearly", value: 525960 },
                // { label: "Last X Day", value: 1441 },
              ]}
            />
          </Form.Item>
        </Col>
        <Col xs={6}>
          {intervalTime && (
            <Form.Item label="Interval Value" name="intervalValue">
              <InputNumber className="w-100" controls={false} placeholder="Enter Value" />
            </Form.Item>
          )}
        </Col>
      </Row>

      {/* operator */}
      {formData.intervalTime && (
        <Form.Item label="Select Operator" name="operator">
          <Radio.Group>
            <Radio value="max">Maximum</Radio>
            <Radio value="min">Minimum</Radio>
            <Radio value="avg">Average</Radio>
            <Radio value="sum">Sum</Radio>
            {/* <Radio value="">Real Time</Radio> */}
          </Radio.Group>
        </Form.Item>
      )}
    </>
  );
};

export default ComparisonTimes;

ComparisonTimes.propTypes = {
  formData: PropTypes.object.isRequired,
};
